import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

var cloneDeep = require("lodash.clonedeep");

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/nl/mijn-dagplanning/",
            name: "empty-configurator",
            component: loadView("configurator/index"),
            children: [
                {
                    path: "gedeeld/:publicKey",
                    name: "configurator-detail-public",
                    component: loadView("configurator/show"),
                    meta: {
                        type: "auth",
                        name: "configurator-detail",
                        beforeResolve(to, from, next) {
                            store.dispatch(
                                "dayConfigurator/setPageLoading",
                                true
                            ); 
                            Promise.all([
                                store
                                    .dispatch(
                                        "dayConfigurator/readPublic",
                                        to.params.publicKey
                                    )
                                    .catch(() => null)
                            ]).then(() => {
                                let activities =
                                    store.getters["dayConfigurator/schedule"]
                                        .activities;
                                let gifts =
                                    store.getters["dayConfigurator/schedule"]
                                        .gifts;
                                let requested_activities = activities.concat(
                                    gifts
                                );

                                store.dispatch(
                                    "dayConfigurator/readExternalActivities",
                                    requested_activities
                                );
                                store.dispatch(
                                    "dayConfigurator/setPageLoading",
                                    false
                                );
                                next();
                            });
                        }
                    }
                },
                {
                    path: "sjabloon/:publicKey",
                    name: "configurator-template",
                    component: loadView("configurator/show"),
                    meta: {
                        type: "auth",
                        name: "configurator-detail",
                        beforeResolve(to, from, next) {          
                            store.dispatch(
                                "dayConfigurator/setPageLoading",
                                true
                            );                  
                            Promise.all([
                                store
                                    .dispatch(
                                        "dayConfigurator/readPublic",
                                        to.params.publicKey
                                    )
                                    .catch(() => null)
                            ]).then(() => {
                                let schedule = cloneDeep(
                                    store.getters["dayConfigurator/schedule"]
                                );

                                schedule.shares = [];

                                store
                                    .dispatch(
                                        "dayConfigurator/duplicatePublic",
                                        schedule
                                    )
                                    .then((duplicateSchedule) => {
                                        store.dispatch(
                                            "dayConfigurator/setPageLoading",
                                            false
                                        );
                                        next({
                                            path: `/nl/mijn-dagplanning/${duplicateSchedule.id}`
                                        });
                                    });
                            });
                        }
                    }
                },
                {
                    path: ":id",
                    name: "configurator-detail",
                    component: loadView("configurator/show"),
                    meta: {
                        type: "auth",
                        name: "configurator-detail",
                        beforeResolve(to, from, next) {
                            store.dispatch(
                                "dayConfigurator/setPageLoading",
                                true
                            ); 
                            Promise.all([
                                store
                                    .dispatch(
                                        "dayConfigurator/read",
                                        to.params.id
                                    )
                                    .catch(() => null)
                            ]).then(() => {
                                let activities =
                                    store.getters["dayConfigurator/schedule"]
                                        .activities;
                                let gifts =
                                    store.getters["dayConfigurator/schedule"]
                                        .gifts;
                                let requested_activities = activities.concat(
                                    gifts
                                );

                                store.dispatch(
                                    "dayConfigurator/readExternalActivities",
                                    requested_activities
                                );
                                store.dispatch(
                                    "dayConfigurator/setPageLoading",
                                    false
                                );
                                next();
                            });
                        }
                    }
                }
            ]
        }
    ]
});

function loadView(view) {
    return () =>
        lazyLoadView(
            import(
                /* webpackChunkName: "chunk/[index]" */ `@/views/${view}.vue`
            )
        );
}

/**
 * Lazy-loads view components, but with better UX. A loading view
 * will be used if the component takes a while to load, falling
 * back to a timeout view in case the page fails to load. You can
 * use this component to lazy-load a route with:
 *
 * component: () => lazyLoadView(import('@views/my-view'))
 *
 * @param {AsyncView} The view component
 */
function lazyLoadView(AsyncView) {
    const AsyncHandler = () => ({
        component: AsyncView,
        delay: 400,
        timeout: 10000
    });

    return Promise.resolve({
        functional: true,
        render(h, { data, children }) {
            return h(AsyncHandler, data, children);
        }
    });
}

router.beforeResolve(async (routeTo, routeFrom, next) => {
    try {
        // For each matched route...
        for (const route of routeTo.matched) {
            await new Promise((resolve, reject) => {
                if (route.meta && route.meta.title) {
                    document.title = route.meta.title;
                }

                if (route.meta && route.meta.beforeResolve) {
                    route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
                        // If the user chose to redirect...
                        if (args.length) {
                            // Complete the redirect.
                            next(...args);
                            reject(new Error("Redirected"));
                        } else {
                            resolve();
                        }
                    });
                } else {
                    // Otherwise, continue resolving the route.
                    resolve();
                }
            });
        }
        // If a `beforeResolve` hook chose to redirect, just return.
    } catch (error) {
        return;
    }
    // If we reach this point, continue resolving the route.
    next();
});

export default router;
